import { render } from "./Item4.vue?vue&type=template&id=6761c019"
import script from "./Item4.vue?vue&type=script&lang=js"
export * from "./Item4.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__